const schemas = require('./schemas');
const POST = 'postJSON';
const PATCH = 'patchJSON';
const GET = 'getJSON';
const DELETE = '_delete';
const PUT = 'put';

const endpoint = (path, method, schema) => ({
  path,
  method,
  schema,
});

module.exports.schemas = schemas;

module.exports.api = {
  login: endpoint('/login', POST, schemas.login),
  jwtLogin: endpoint('/jwt-login', POST),
  logout: endpoint('/logout', POST),
  impersonate: endpoint('/impersonate', POST, schemas.impersonate),
  checkCommunicationChannels: endpoint('/check-communication-channels', POST),
  acceptCookieBanner: endpoint('/accept-cookie-banner', POST),
  sendContactUsEmail: endpoint('/send-contact-us-email', POST, schemas.sendContactBody),

  // Demo users
  validateDemoUser: endpoint('/validate-demo-user', POST),
  updateLocation: endpoint('/update-location', POST),

  // Links
  magicLink: endpoint('/magic-link', POST, schemas.magicLink),
  resetPassword: endpoint('/reset-password', POST, schemas.magicLink),
  validateResetToken: endpoint('/change-password/:token', GET),
  changePassword: endpoint('/change-password', POST, schemas.changePassword),
  setCredentials: endpoint('/installers/credentials', POST, schemas.setupInstaller),

  magicLinkUser: endpoint('/users/:userId/magic-link', POST),
  resetPasswordUser: endpoint('/users/:userId/reset-password', POST),
  resetSelfPasswordUser: endpoint('/users/reset-password', POST),
  sendInviteUser: endpoint('/users/:userId/send-invite', POST),

  // Users
  info: endpoint('/users/self', GET),
  self: endpoint('/users/self', GET),
  updateSelf: endpoint('/users/self', PATCH),
  listUsers: endpoint('/users', GET),
  createUser: endpoint('/users', POST, schemas.createUser),
  updateUser: endpoint('/users/:userId', PATCH, schemas.updateUser),
  getUser: endpoint('/users/:userId', GET),
  readInstaller: endpoint('/users/installers/:userId'),
  createUserAdmin: endpoint('/users/admins', POST, schemas.createUserAdmin),
  addDeviceToken: endpoint('/users/device-tokens', POST, schemas.addDeviceToken),
  removeDeviceToken: endpoint('/users/device-tokens/:deviceToken', DELETE),
  removeDeviceTokenInternal: endpoint('/users/internal-api/device-tokens', DELETE),
  userNotificationSettingsSub: endpoint('/users/settings/subs/notifications'),
  userNotificationSettingsBuilder: endpoint('/users/settings/builders/notifications'),
  getFilterSettings: endpoint('/users/settings/filters'),
  updateUserNotificationSettings: endpoint('/users/settings/:userId/notifications', PATCH),
  updateFilterSettings: endpoint('/users/settings/filters/:filterName', PUT),
  readRelevantTasks: endpoint('/users/settings/notifications/relevant-tasks'),
  createRelevantTasks: endpoint('/users/settings/notifications/relevant-tasks', POST),
  updateRelevantTasks: endpoint('/users/settings/notifications/relevant-tasks', PATCH),
  deleteRelevantTasks: endpoint('/users/settings/notifications/relevant-tasks', DELETE),
  readLeadTimeTasks: endpoint('/users/settings/notifications/lead-time-tasks'),
  readLeadTimeTaskDetail: endpoint('/users/settings/notifications/lead-time-tasks/:leadTimeTaskId'),
  createLeadTimeTask: endpoint('/users/settings/notifications/lead-time-tasks', POST),
  updateLeadTimeTask: endpoint('/users/settings/notifications/lead-time-tasks/:leadTimeTaskId', PATCH),
  deleteLeadTimeTask: endpoint('/users/settings/notifications/lead-time-tasks/:leadTimeTaskId', DELETE),
  updateNotificationSettings: endpoint('/users/settings/notification', PATCH),
  updateGlobalNotifications: endpoint('/users/settings/global-notification', PATCH),
  // Settings -> JobFilters
  readJobFilters: endpoint('/users/settings/job-filters'),
  readJobFilter: endpoint('/users/settings/job-filters/:filterId'),
  createJobFilter: endpoint('/users/settings/job-filters', POST),
  updateJobFilter: endpoint('/users/settings/job-filters/:filterId', PATCH),
  deleteJobFilter: endpoint('/users/settings/job-filters/:filterId', DELETE),
  shareJobFilter: endpoint('/users/settings/job-filters/:filterId/share', POST),
  unshareJobFilter: endpoint('/users/settings/job-filters/:filterId/unshare', POST),
  readJobFilterUsersAndRoles: endpoint('/users/settings/job-filters/:filterId/users-roles', GET),
  batchUpdateJobFilters: endpoint('/users/settings/job-filters', PUT),
  getUserActivities: endpoint('/users/recent-activities', GET),
  //Don't use on front end, use subsServices or builderService one instead
  internalUpdatePermissionsSub: endpoint('/users/subs/:userId/permissions', PATCH),
  internalUpdatePermissionsBuilder: endpoint('/users/builders/:userId/permissions', PATCH),

  // Homeowner Endpoints
  createHomeowner: endpoint('/users/homeowners', POST),
  listHomeowners: endpoint('/users/homeowners', GET),
  getHomeowner: endpoint('/users/homeowners/:userId', GET),
  listHomeownerBuilderAssignees: endpoint('/users/homeowners/builder-assignees', GET),
  listHomeownerCommunities: endpoint('/users/homeowners/communities', GET),
  updateHomeowner: endpoint('/users/homeowners/:userId', PATCH),
  addJobToHomeowner: endpoint('/users/homeowners/:userId/jobs/:jobId', PUT),
  removeJobFromHomeowner: endpoint('/users/homeowners/:userId/jobs/:jobId', DELETE),

  createRole: endpoint('/roles', POST),
  listRoles: endpoint('/roles', GET),
  getRole: endpoint('/roles/:roleId', GET),
  updateRole: endpoint('/roles/:roleId', PATCH),
  deleteRole: endpoint('/roles/:roleId', DELETE),
  readRoleJobFilters: endpoint('/roles/:roleId/job-filters'),

  // Installers Librry
  viewInstallers: endpoint('/users/installers', GET),
  createUserInstaller: endpoint('/users/installers', POST),
  deleteInstaller: endpoint('/users/installers/:installerId', DELETE),

  // Internal calls
  internalListUsers: endpoint('/users/internal-api', GET),
  internalReadUser: endpoint('/users/internal-api/:userId', GET),
  internalUpdateUser: endpoint('/users/internal-api/:userId', PATCH),
  internalGetAccountUsers: endpoint('/users/internal-api/accounts/:accountId'),
  internalUpdateAccountName: endpoint('/users/internal-api/accounts/:accountId', PUT),
  internalGetAccountManager: endpoint('/users/internal-api/accounts/:accountId/manager'),
  internalUpdateAccountManager: endpoint('/users/internal-api/accounts/:accountId/manager', PATCH),
  queryUsers: endpoint('/users/internal-api/query-users', GET),
  internalQueryUsersNotifications: endpoint('/users/internal-api/query-users-notifications', GET),
  queryByPermissions: endpoint('/users/internal-api/query-by-permissions', GET),
  getHomeownersJobs: endpoint('/users/internal-api/homeowners/jobs', GET),
  deleteUsers: endpoint('/users', DELETE),
  syncTask: endpoint('/internal-api/sync/task/:gtlTaskId', POST),
  syncAccount: endpoint('/internal-api/sync/account/:accountId', POST),
  syncJob: endpoint('/internal-api/sync/job/:jobId', POST),
  syncCommunity: endpoint('/internal-api/sync/community/:communityId', POST),
  newUserActivityEvent: endpoint('/users/internal-api/user-activity-events', POST),
  createJob: endpoint('/users/internal-api/jobs/:jobId', POST),
  deleteJob: endpoint('/users/internal-api/jobs/:jobId', DELETE),
  deleteNote: endpoint('/users/internal-api/notes/:noteId', DELETE),
  deleteAttachment: endpoint('/users/internal-api/attachments/:attachmentId', DELETE),
  deleteTask: endpoint('/users/internal-api/jobs/:jobId/tasks/:taskId', DELETE),
  updateTask: endpoint('/users/internal-api/jobs/:jobId/tasks/:taskId', PATCH),
  searchUsers: endpoint('/users/internal-api/search', GET),

  //builder user management
  listBuilderUsers: endpoint('/users/builders', GET),
  createBuilderUser: endpoint('/users/builders  ', POST, schemas.createUser),
  updateBuilderUser: endpoint('/users/builders/:userId', PATCH, schemas.updateUser),
  getBuilderUser: endpoint('/users/builders/:userId', GET),
  //installer user management
  updateSelfInstaller: endpoint('/users/installers-users/self', PATCH),

  //feature flags
  getFeatureFlag: endpoint('/feature-flags/:toggleName', GET),
  getFeatureFlags: endpoint('/feature-flags/batch-check', POST, schemas.featureToggleRequestArray),
};

module.exports.events = {
  PERMISSION_UPDATED: 'permissionsUpdated',
  PROFILE_ACTIVE: 'profileActive',
};
